<template>
  <nuxt-link
    :to="to"
    class="col col-4 training-card"
    :class="{ dark }"
  >
    <div class="image-holder">
      <img loading="lazy" :src="$webp(`${$config.imagesUrl}/live-trainings/${training.smallImage}`)" :alt="training.author">
    </div>
    <component :is="heading" class="h5">
      {{ training.title }}
    </component>
    <p>
      with {{ training.author }}
    </p>
    <div v-if="!hideDescription" class="description">
      {{ training.shortDescription }}
    </div>
    <div class="card-footer">
      <span>
        {{ training.duration }}
      </span>
      <li>
        <span>
          {{ training.difficulty }}
        </span>
      </li>
    </div>
  </nuxt-link>
</template>

<script>
export default {
  props: {
    training: { type: Object, required: true },
    dark: Boolean,
    hideDescription: Boolean,
    to: { type: String, default: '', required: true },
    heading: { type: String, default: 'h2', required: false },
  },
};
</script>

<style lang='scss'>
.training-card {
  text-decoration: none;
  color: var(--main-dark-shade-0);
  margin-bottom: var(--spacing-32);
  transition: transform var(--duration) ease;

  &.dark {
    color: var(--main-light);

    .topic,
    .description,
    .card-footer {
      color: var(--main-light-shade-4);
    }
  }

  &:hover {
    color: inherit;
    transform: scale(1.03);

    .h5 {
      color: var(--accent);
    }
  }

  .image-holder {
    height: 192px;
    width: 100%;
    max-width: 370px;
    position: relative;
    display: inline-block;
    margin-bottom: var(--spacing-16);

    img {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: top;
      border-radius: 10px;
    }

    .price-label {
      position: absolute;
      bottom: var(--spacing-8);
      right: var(--spacing-8);
      padding: var(--spacing-4) var(--spacing-8);
      background-color: var(--main-dark);
      color: var(--main-light);
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .topic {
    font-size: 14px;
    color: var(--main-dark-light-3);
  }

  .h5 {
    font-weight: 500;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: block;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  p {
    margin-top: 0;
  }

  .description {
    color: var(--main-dark-light-4);
    margin-bottom: var(--spacing-16);
  }

  .card-footer {
    display: flex;
    font-size: 14px;
    color: var(--main-dark-light-4);

    li {
      margin-left: var(--spacing-8);
      list-style: none;

      &:before {
        content: '•';
        margin-right: 4px;
      }

      span {
        position: relative;
      }
    }
  }
}

@include bp($bp-mobile) {
  .training-card {
    .image-holder {
      height: 221px;
    }
  }
}

</style>
